import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import messageFromError from "../utils/errorUtils";
import {
    getGlobalAppSettings,
    getGlobalGeneralSettings,
    updateGlobalAppSettings,
    updateGlobalGeneralSettings
} from "../API/companyApi";
import SettingsContainer from "./SettingsPage/Components/SettingsContainer";
import {SETTINGS_APP} from "../Constants";

const GlobalSettingsPage = () => {
    const [appSettings, setAppSettings] = useState()
    const [generalSettings, setGeneralSettings] = useState()
    const [isUpdatingSettings, setIsUpdatingSettings] = useState(false)

    const {t} = useTranslation()

    useEffect(() => {
        fetchAppSettings()
        fetchGeneralSettings()
    }, []);

    async function fetchAppSettings() {
        const response = await getGlobalAppSettings()
        setAppSettings(response.data);
    }

    async function fetchGeneralSettings() {
        const response = await getGlobalGeneralSettings()
        setGeneralSettings(response.data);
    }

    const updateSettings = async (settings, appOrGeneral = SETTINGS_APP) => {
        setIsUpdatingSettings(true)
        try {
            if(appOrGeneral === SETTINGS_APP)
            {
                await updateGlobalAppSettings(settings)
            }
            else {
                await updateGlobalGeneralSettings(settings)
            }

            if(appOrGeneral === SETTINGS_APP)
            {
                fetchAppSettings()
            }
            else {
                fetchGeneralSettings()
            }

            toast.success('Settings updated successfully')
        }
        catch(error)
        {
            toast.error(messageFromError(error))
        }
        finally {
            setIsUpdatingSettings(false)
        }
    }

    return <SettingsContainer appSettings={appSettings} generalSettings={generalSettings} updateSettings={updateSettings} isUpdatingSettings={isUpdatingSettings} editable={!isUpdatingSettings}/>
};

export default GlobalSettingsPage;